import updateApprovals from '../actions/updateApprovals';
import updateApprovalsPendingCount from '../actions/updateApprovalsPendingCount';

export default function approvalsReducer(state = { data: [], pendingCount: 0 }, action) {
    switch (action.type) {
        case updateApprovals.type:
            return {
                data: action.payload,
                pendingCount: action.payload.filter((item) => item.attributes.status === 'pending').length,
            };

        case updateApprovalsPendingCount.type:
            return { ...state, pendingCount: action.payload };
        default:
            return state;
    }
}
